const hi = {
  home: {
    biometric_label: "बायोमेट्रिक पहचान सत्यापन",
    title: "चेहरों की रिवर्स खोज को आसान बनाएं",
    description:
      "उन्नत न्यूरल मिलान का उपयोग करके वैश्विक डिजिटल अभिलेखागारों के साथ क्रॉस-रेफरेंस करने के लिए एक उच्च-रिज़ॉल्यूशन पोर्ट्रेट अपलोड करें।",
    drag_drop: "अपनी छवि यहाँ खींचें और छोड़ें",
    file_formats: "RAW, JPEG या PNG सपोर्ट करता है (अधिकतम 15MB)",
    select_file: "सिस्टम से फ़ाइल चुनें",
    initiate_scan: "फोरेंसिक स्कैन शुरू करें",
    upload_hint: "जारी रखने के लिए कृपया एक छवि अपलोड करें",
    uploading: "अपलोड हो रहा है",
    searching: "स्कैन हो रहा है",
    result_title: "परिणाम",
    drop_here: "छवि यहाँ छोड़ें...",
    billion_faces: "इंटरनेट पर 1 अरब से अधिक चेहरों से तुलना करें",
    login_to_search: "खोजने के लिए लॉगिन करें",
    login_required: "इस ऐप का उपयोग करने के लिए लॉगिन करें या अकाउंट बनाएं",
    not_enough_tokens: "पर्याप्त टोकन नहीं हैं",
    please_wait: "कृपया कुछ मिनट प्रतीक्षा करें",
    leave_confirmation:
      "एक प्रक्रिया चल रही है। क्या आप वाकई छोड़ना चाहते हैं?",
  },
  sources: {
    section_title: "हम किन स्रोतों में खोजते हैं",
    social_media: {
      name: "सोशल मीडिया",
      description:
        "प्रमुख सोशल नेटवर्क और सार्वजनिक प्रोफ़ाइल में क्रॉस-रेफरेंस।",
    },
    web: {
      name: "वेब",
      description:
        "सार्वजनिक रूप से उपलब्ध चेहरे के डेटा के लिए ओपन वेब स्कैन करता है।",
    },
    scammers: {
      name: "धोखेबाज",
      description: "ज्ञात धोखेबाजों की पहचान और धोखाधड़ी डेटाबेस से मिलान।",
    },
    sexual_offenders: {
      name: "यौन अपराधी",
      description:
        "सार्वजनिक पंजीकृत अपराधी रजिस्ट्रियों के साथ क्रॉस-रेफरेंस।",
    },
    videos: {
      name: "वीडियो",
      description:
        "सार्वजनिक वीडियो प्लेटफ़ॉर्म से चेहरे निकालता और मिलान करता है।",
    },
    police_photos: {
      name: "पुलिस फ़ोटो",
      description: "सार्वजनिक रूप से उपलब्ध पुलिस रिकॉर्ड डेटाबेस से तुलना।",
    },
    news_and_blogs: {
      name: "समाचार और ब्लॉग",
      description: "समाचार अभिलेखागार, संपादकीय सामग्री और ब्लॉग में खोज।",
    },
  },
  header: {
    scan: "स्कैन",
    history: "इतिहास",
    pricing: "मूल्य निर्धारण",
    account: "खाता",
    logout: "लॉगआउट",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. सभी अधिकार सुरक्षित। सटीक पहचान सत्यापन।",
    privacy: "गोपनीयता नीति",
    terms: "सेवा की शर्तें",
    docs: "दस्तावेज़ीकरण",
    support: "सहायता",
  },
  common: {
    loading: "लोड हो रहा है...",
    error: "त्रुटि",
    cancel: "रद्द करें",
    back: "वापस",
  },
  errors: {
    upload_failed: "अपलोड विफल। कृपया पुनः प्रयास करें।",
    not_enough_tokens: "आपके पास यह खोज करने के लिए पर्याप्त टोकन नहीं हैं।",
  },
  login: {
    disclaimer:
      "इस ऐप का उपयोग करने के लिए आपको एक खाते की आवश्यकता है। हम स्पैम नहीं भेजते और आपका ईमेल साझा नहीं करते। गोपनीयता के लिए Apple से लॉगिन करने की सलाह देते हैं।",
  },
  results: {
    input_source: "इनपुट स्रोत",
    match_thumbnail: "मिलान थंबनेल",
    extraction_id: "निष्कर्षण आईडी",
    scan_analysis: "स्कैन विश्लेषण",
    scan_description:
      "बायोमेट्रिक रिवर्स लुकअप पूर्ण हुआ। सार्वजनिक रजिस्ट्री और सामाजिक सूचकांकों में %{count} संभावित मिलान मिले।",
    col_identity_map: "पहचान मानचित्र",
    col_verification_path: "सत्यापन पथ",
    col_bio_match_score: "बायो मैच स्कोर",
    col_action: "कार्रवाई",
    export_pdf: "PDF निर्यात",
    exporting: "तैयार हो रहा है...",
    verified: "सत्यापित",
    details: "विवरण",
    details_tooltip: "सटीक चेहरा तुलना चलाएं",
    details_loading: "तुलना हो रही है...",
    copied: "कॉपी किया!",
    copy_url: "URL कॉपी करें",
    displaying: "%{total} में से %{count} पहचान दिखा रहा है",
  },
};

export default hi;
